import { publicClubCtaItems } from '@/content/public/publicPageContent';

export default {
  name: 'PublicClubCta',
  data() {
    return {
      ctaItems: publicClubCtaItems,
    };
  },
};
